import { useContext } from 'react';
import { popperArrowContext } from './context';

export const usePopperArrowContext = () => useContext(popperArrowContext);
